import { ApolloError } from '@apollo/client'
import { AxiosPromise } from 'axios'
import { PromiseErrorContextValue, useErrorHandler } from 'components/error'
import { saveAs } from 'file-saver'

interface DownloadFileProps<T> {
  apiPath: (values: T) => AxiosPromise<Blob | ArrayBuffer>
  values: T
  file: string
  handleCatch?: PromiseErrorContextValue
  onSuccess?: () => void
}

export function useDownloadFile() {
  const handleRejection = useErrorHandler()

  const downloadFile = (blob: Blob, fileName: string) => saveAs(blob, fileName)

  const downloadFileWithPath = async <T>(props: Readonly<DownloadFileProps<T>>) => {
    const { apiPath, values, file, onSuccess, handleCatch = handleRejection } = props

    try {
      const response = await apiPath(values)
      onSuccess?.()
      const blob = new Blob([response.data])
      saveAs(blob, file)
      return response
    } catch (error) {
      return handleCatch(error as ApolloError)
    }
  }

  return {
    downloadFile,
    downloadFileWithPath,
  }
}
